import { render, staticRenderFns } from "./BulkAddMathAssessmentComponent.vue?vue&type=template&id=d81b0da0"
import script from "./BulkAddMathAssessmentComponent.vue?vue&type=script&lang=js"
export * from "./BulkAddMathAssessmentComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports